import { api } from '../lib/api';

export interface PalateFacet {
  label: string;
  average: number;
  groupAverage: number;
  /** average − groupAverage. Positive = you like this more than the room does. */
  delta: number;
  count: number;
}

export interface PalateProfile {
  scoresCast: number;
  eventsScored: number;
  generosity: number;
  overallAverage: number;
  groupOverallAverage: number;
  byVarietal: PalateFacet[];
  byColor: PalateFacet[];
  byRegion: PalateFacet[];
  byDecade: PalateFacet[];
  topWines: { id: string; name: string; producer: string | null; vintage: number | null; total: number }[];
}

export const palateApi = {
  get: (memberId: string) =>
    api.get<{ data: PalateProfile }>(`/members/${memberId}/palate`).then((r) => r.data),
};
